export const convertHexToRGBA = (hexObject, transparency) => {
  const convertSingleHex = hex => {
    const cleanHex = hex.replace('#', '');
    const r = Number.parseInt(cleanHex.substring(0, 2), 16);
    const g = Number.parseInt(cleanHex.substring(2, 4), 16);
    const b = Number.parseInt(cleanHex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${transparency})`;
  };

  return Object.entries(hexObject).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: convertSingleHex(value),
    }),
    {},
  );
};
